import { render } from "./CardVendasClassTotal.vue?vue&type=template&id=9fadf24a"
import script from "./CardVendasClassTotal.vue?vue&type=script&lang=js"
export * from "./CardVendasClassTotal.vue?vue&type=script&lang=js"

import "./CardVendasClassTotal.vue?vue&type=style&index=0&id=9fadf24a&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__